import { useState } from 'react';

const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxtthJjtQlW2jXOCDRhwlm6TEx06sJFtyyzRbtgn19RUIon3YJoS-XP2uY_Al8pWg4sEQ/exec'; // ← sostituisci con la tua URL

function App() {
  const [form, setForm] = useState({
    nome: '', cognome: '', dataNascita: '', citta: '',
    email: '', telefono: '', ricontattare: false
  });
  const [stato, setStato] = useState('');

  const aggiorna = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const invia = async (e) => {
    e.preventDefault();
    setStato('invio');
    try {
      await fetch(SCRIPT_URL, {
        method: 'POST',
        body: JSON.stringify(form)
      });
      setStato('ok');
      setForm({ nome: '', cognome: '', dataNascita: '', citta: '', email: '', telefono: '', ricontattare: false });
    } catch {
      setStato('errore');
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '40px auto', fontFamily: 'sans-serif', padding: '0 20px' }}>
      <h1>Registrazione</h1>
      {stato === 'ok' && <p style={{ color: 'green' }}>✅ Registrazione avvenuta con successo!</p>}
      {stato === 'errore' && <p style={{ color: 'red' }}>❌ Errore, riprova.</p>}
      <form onSubmit={invia}>
        {[
          { label: 'Nome', name: 'nome', type: 'text' },
          { label: 'Cognome', name: 'cognome', type: 'text' },
          { label: 'Data di nascita', name: 'dataNascita', type: 'date' },
          { label: 'Città', name: 'citta', type: 'text' },
          { label: 'Email', name: 'email', type: 'email' },
          { label: 'Telefono', name: 'telefono', type: 'tel' },
        ].map(({ label, name, type }) => (
          <div key={name} style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4 }}>{label}</label>
            <input
              type={type} name={name} value={form[name]}
              onChange={aggiorna} required
              style={{ width: '100%', padding: 8, fontSize: 16, boxSizing: 'border-box' }}
            />
          </div>
        ))}
        <div style={{ marginBottom: 16 }}>
          <label>
            <input type="checkbox" name="ricontattare" checked={form.ricontattare} onChange={aggiorna} />
            {' '}Desidero essere ricontattato
          </label>
        </div>
        <button type="submit" disabled={stato === 'invio'}
          style={{ padding: '10px 24px', fontSize: 16, cursor: 'pointer' }}>
          {stato === 'invio' ? 'Invio...' : 'Registrati'}
        </button>
      </form>
    </div>
  );
}

export default App;